import * as CryptoJS from 'crypto-js';
import * as i0 from "@angular/core";
export class EncryptionProviderService {
    constructor() {
        this.key = CryptoJS.enc.Latin1.parse('aar6tzij8o1snaar');
        this.iv = CryptoJS.enc.Latin1.parse('0123456789ABCDEF');
        this.guidArray = [];
    }
    encryptData(dataToEncrypt) {
        const encrypted = CryptoJS.AES.encrypt(dataToEncrypt, this.key, {
            iv: this.iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7,
        });
        return encrypted.toString();
    }
    decryptData(dataToDecrypt) {
        const decrypted = CryptoJS.AES.decrypt(dataToDecrypt, this.key, {
            iv: this.iv,
            padding: CryptoJS.pad.Pkcs7,
        });
        return decrypted.toString(CryptoJS.enc.Utf8);
    }
    getGuid(endPoint) {
        let selectedArr;
        this.guidArray.forEach((v, i, arr) => {
            if (v.key === endPoint) {
                selectedArr = v;
                return;
            }
        });
        return selectedArr.value;
    }
    setGuid(arr) {
        for (let i = 0; i < this.guidArray.length; i++) {
            if (this.guidArray[i].key === arr.key) {
                this.guidArray.splice(i, 1);
            }
        }
        this.guidArray.push(arr);
    }
}
EncryptionProviderService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function EncryptionProviderService_Factory() { return new EncryptionProviderService(); }, token: EncryptionProviderService, providedIn: "root" });
